<template>
  <div>
    <div class="userinfo">
      <div class="info_left">
        <div class="info_left_img">
          <img src="../../image/userimg.png" />
        </div>
        <div class="info_left_text">
          <div class="userName">{{ userInfo.nickName }}</div>
          <div class="authentication" v-if="userInfo.isRealName == 1">
            已认证
          </div>
          <div class="authentication_else" v-else>未认证</div>
          <div class="userNumber">
            手机号：{{ userInfo.phonenumber }}
          </div>
        </div>
      </div>
      <div class="info_right">
        <el-button
          v-if="
            userInfo.status == '1' &&
              premission('Switch:landlord:status')
          "
          type="danger"
          style="backgroundColor: #EB5757;border:1px solid  #EB5757 "
          @click="TenantChangeStatusAjax"
          >禁用</el-button
        >
        <el-button
          type="danger"
          v-if="
            userInfo.status == '0' &&
              premission('Switch:landlord:status')
          "
          style="backgroundColor: #EB5757;border:1px solid  #EB5757 "
          @click="TenantChangeStatusAjax"
          >启用</el-button
        >
<!--        <el-button
          style="backgroundColor:#219653;border:1px solid #219653 "
          @click="resetPasswordBtn"
          v-if="premission('Reset:landlord:password')"
          >重置密码</el-button
        >-->
        <el-button
          style="backgroundColor:#F6B439;border:1px solid #F6B439 "
          @click="allotBtn"
          v-if="premission('Distribution:Operations:Manager')"
          >分配运营管家</el-button
        >
        <el-button
          style="backgroundColor:#EF6E2D;border:1px solid #EF6E2D "
          @click="deleteTenant"
          v-if="premission('Delete:landlord')"
          >删除</el-button
        >
        <el-button
          style="backgroundColor:#2F80ED;border:1px solid #2F80ED "
          @click="editInformation"
          v-if="premission('Edit:landlord')"
          >编辑</el-button
        >
      </div>
    </div>
    <div class="title">服务责任人</div>
    <div class="user_message">
      <div class="message">
        <div class="message_left">投资顾问：{{ userInfo.cAdviser }}</div>
        <div class="message_right">区域经理：{{ userInfo.cTalks }}</div>
      </div>
      <div class="message">
        <div class="message_left">设计师：{{ userInfo.cDispatch }}</div>
        <div class="message_right">
          运营管家：{{ userInfo.cSteward }}
        </div>
      </div>
    </div>
    <div class="title">客户基本信息</div>
    <div class="user_message">
      <div class="message">
        <div class="message_left">生日：{{ userInfo.birthday }}</div>
        <div class="message_right">常住城市 ：{{ userInfo.city }}</div>
      </div>
      <div class="message">
        <div class="message_left">性别：{{ userInfo.sex==1?'男':'女' }}</div>
        <div class="message_right">
          注册时间：{{ userInfo.createTime }}
        </div>
      </div>
      <div class="message">
        <div class="message_left">年龄：{{ userInfo.age }}岁</div>
        <div class="message_right">来源：{{ userInfo.source }}</div>
      </div>
      <div class="message">
        <div class="message_left">职业：{{ userInfo.profession }}</div>
        <!-- <div class="message_right">常住城市：武汉</div> -->
      </div>
    </div>
    <div class="title">数据统计</div>
    <div class="user_message">
      <div class="message">
        <div class="message_left">待上线：</div>
        <div class="message_right">已上线：</div>
      </div>
      <div class="message">
        <div class="message_left">已下架:</div>
        <div class="message_right">退款订单数：</div>
      </div>
      <div class="message">
        <div class="message_left">总售卖天数：天</div>
        <div class="message_right">总售卖金额：￥</div>
      </div>
    </div>
    <div class="title">订单记录</div>
    <!-- 表单数据 -->
    <div class="record">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="orderId" label="订单编号" width="180">
        </el-table-column>
        <el-table-column prop="commitTime" label="提交时间" width="180">
        </el-table-column>
        <el-table-column prop="phonenumber" label="用户账号" width="180">
        </el-table-column>
        <el-table-column prop="money" label="订单金额" width="180">
        </el-table-column>
        <el-table-column prop="payType" label="支付方式" width="180">
        </el-table-column>
        <el-table-column prop="source" label="订单来源" width="180">
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="180">
        </el-table-column>
        <el-table-column prop="name" label="状态"> </el-table-column>
      </el-table>
    </div>
    <div class="title">沟通日志</div>
    <!-- 沟通日志 -->
    <!-- <template slot-scope="scope">
     @click="getImg()"
            </template> -->
    <!-- <div class="record">
      <div class="communication_box">
        <div
          class="communication_list"
          v-for="(item, index) in boxList"
          :key="index"
        >
          <div class="communication_list_top">
            {{ item.cOperator }}：({{ item.cDescribe }}){{ item.cOperMemo }}
          </div>
          <div class="communication_list_center">{{ item.dOperaTime }}</div>
          <div class="communication_list_bottom" v-if="item.picList.length > 0">

            <div
              class="QuickMark"
              v-for="(item2, index1) in item.picList"
              :key="index1"
              @click="getImg(item2)"
            >
              <el-image
                style="width: 100%; height: 100%"
                :src="item2"
                :preview-src-list="srcList"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </div>
      </div>
      <div
        class="checkBox"
        v-if="this.pageSize * this.pageNum < this.total"
        @click="moreList"
      >
        展开更多<i
          class="el-icon-arrow-down
"
        ></i>
      </div>
    </div> -->
    <!-- 回复框 -->
    <div class="record">
      <div class="reply">
        <div class="reply_text">
          <el-input
            maxlength="500"
            type="textarea"
            autosize
            resize="none"
            placeholder="表明你想说的话..."
            v-model="cOperMemo"
          >
          </el-input>
        </div>
        <!-- 上传图片 action="http://192.168.2.120:8808/system/user/profile/wxCode"
               action="http://youjiaminsu.cn:8808/system/user/profile/avatar" -->
        <div class="reply_img">
          <el-upload
            ref="my-upload"
            :limit="5"
            :headers="headers"
            name="avatarfile"
            action="/api/system/user/profile/wxCode"
            list-type="picture-card"
            :on-success="handleAvatarSuccessFour"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible_img">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <el-button @click="replyBtn">
            <i class="el-input__icon iconfont iconfasong"></i>上传
          </el-button>
        </div>
      </div>
    </div>
    <!-- 个人档案 -->
    <el-dialog
      title="个人档案"
      class="title_center"
      :visible.sync="userInfoVisible"
      width="600px"
      :show-close="false"
    >
      <el-form :model="userInfoFrom" ref="userInfoFrom" :rules="rules" label-width="120px">
        <el-form-item label="身份证号：" prop="cCusIdCard">
          <el-input
            v-model="userInfoFrom.cCusIdCard"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日：" prop="birthday">
            <el-date-picker
                style="width: 100%;"
                v-model="userInfoFrom.birthday"
                type="date"
                placeholder="生日">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="性别：">
          <el-radio v-model="userInfoFrom.sex" label="1">男</el-radio>
          <el-radio v-model="userInfoFrom.sex" label="0">女</el-radio>
        </el-form-item>
        <el-form-item label="昵称：" >
          <el-input v-model="userInfoFrom.nickName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职业：">
          <el-input v-model="userInfoFrom.profession" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="userInfoBtn" class="success_Btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog
      title="重置密码"
      class="title_center"
      :visible.sync="resetVisible"
      width="600px"
      :show-close="false"
    >
      <div class="resetPassText">
        是否将账号密码重置为初始密码（初始密码为12345678）
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="resetUser" class="success_Btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 分配运营管家  -->
    <el-dialog title="分配运营管家" :visible.sync="allotVisible" width="600px">
      <!-- 部门 -->
      <div class="AddLabel">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTagsOne"
          closable
          type="warning"
          :disable-transitions="false"
          @close="handleCloseTagOne(tag)"
        >
          {{ tag }}
        </el-tag>
      </div>
      <!-- 选择部门 -->
      <div class="select_list_tree">
        <div class="treeList">
          <el-tree
            accordion
            :default-expanded-keys="defSelectArr"
            highlight-current
            :data="data"
            :props="defaultProps"
            @node-click="handleNodeClickTwo"
          ></el-tree>
        </div>
        <div class="select_list_checkBox">
          <!-- <div
            class="select_list_checkBox_list"
            v-for="(item, index) in LandlordList"
            :key="index"
          >
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckAllChange"
            >
              <el-checkbox :label="item.deptId">{{
                item.nickName
              }}</el-checkbox>
            </el-checkbox-group>
          </div> -->
          <el-checkbox-group
            :max="1"
            v-model="checkListPost"
            @change="handleCheckAllChange"
          >
            <el-checkbox
              v-for="(item, index) in LandlordList"
              :label="item"
              :key="index"
            >
              {{ item.nickName }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" class="success_Btn" @click="ChangeStatus"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  UserListsAjax,
  LandlordAjax,
  replyAjax,
  resetUserPwd,
  TenantDelete,
  customerChangeStatus,
  TreeselectListsAjax,
  hourseLoadChangeStatus
} from "../../api/index";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  data() {
      let validateIdCard = (rule, value, callback) => {
          let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (!reg.test(value)) {
              callback(new Error('身份证不合法!'));
          }else {
              let birthday=''
              if(value.length == 15){
                  birthday = "19"+value.substr(6,6);
              } else if(value.length == 18){
                  birthday = value.substr(6,8);
              }

              this.userInfoFrom.birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
              if (parseInt(value.slice(-2, -1)) % 2 == 1) {
                  this.userInfoFrom.sex = '1';
              }
              else {
                  this.userInfoFrom.sex = '0';
              }
              console.log(this.userInfoFrom.birthday)
              callback();
          }
      };
    return {
      checkListPostList: "", //获取的管家id
      defSelectArr:[],//tree默认选中
      checkListPost: [],
      LandlordList: [],
      checkList: [],
      stewardId: "",
      // 用户详情
      getLandlordList: [],
      customerId: "",
      pageSize: 5,
      pageNum: 1,
      total: 0,
      data: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      dynamicTagsOne: "",
      allotVisible: false,
      resetVisible: false,
      userInfoVisible: false,
      dialogImageUrl: "",
      dialogVisible_img: false,
      disabled: false,
      // 回复文字
      cOperMemo: "",
      sizeForm: {
        img: []
      },
      formInline: {
        pageNum: 1,
        pageSize: 30,
        userName: "",
        deptPost: "",
        deptId: "100"
      },
      userInfo: {
        customerId: "",
        idCard: "",
        birthday: "",
        sex: "1",
        profession: "",
        nickName: ""
      },
      userInfoFrom:{
          customerId: "",
          idCard: "",
          birthday: "",
          sex: "1",
          profession: "",
          nickName: ""
      },
      boxList: [],
      // 查看大图
      srcList: [],
      tableData: [],
        rules: {
            cCusIdCard: [
                { required: true, message: '请输入身份证', trigger: 'blur' },
                { validator: validateIdCard, trigger: 'blur' }
            ],
            birthday: [
                { required: true, message: '请选中出生日期', trigger: 'blur' }
            ],
        }
    };
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
      };
    }
  },
  created() {
    if (this.$route.params.customerId) {
      sessionStorage.setItem(
        "LandlordcustomerId",
        this.$route.params.customerId
      ); //将params中的值存在本地，并且当他为空时不刷新
    }
    this.userInfo.customerId = sessionStorage.getItem("LandlordcustomerId");
    this.customerId = sessionStorage.getItem("LandlordcustomerId");
    this.pageSize = 5;
    this.pageNum = 1;
    this.total = 0;
    this.getLandlordAjax();
    this.getTreeselectListsAjax();
  },
  methods: {
    //获取树形结构数据
    async getTreeselectListsAjax() {
      const { data: res } = await TreeselectListsAjax({});
      //  parentId: 138
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.data = res.data;
    },
    async getLandlordAjax() {
      const { data: res } = await LandlordAjax({
        customerId: this.customerId,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      });
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.houseId = res.data.info.customerId;
      this.userInfo = res.data.info.customer;
      this.tableData = res.data.orderLists;
      this.boxList = this.boxList.concat(res.data.hourLogs);
      this.total = res.data.total;
        console.log(this.userInfo)
    },

    // 修改房客状态
    async TenantChangeStatusAjax() {
      let text = this.userInfo.status === "0" ? "启用" : "禁用";
      var status = this.userInfo.status === "0" ? "1" : "0";
      this.$confirm("是否确认" + text + "？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await customerChangeStatus({
            status: status,
            customerId: this.customerId
          });
          if (res.code !== 200) {
            status = this.userInfo.status === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
        })
        .catch(() => {
          status = this.userInfo.status === "0" ? "1" : "0";
        });
    },
    // 取消按钮
    cancel() {
      this.userInfoVisible = false;
      this.resetVisible = false;
      this.allotVisible = false;
      this.userInfoFrom = {
        customerId: "",
        cCusIdCard: "",
        birthday: "",
        sex: "1",
        profession: "",
        nickName: ""
      };
    },
    // 删除用户
    deleteTenant() {
      this.$confirm("是否确认删除？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // cancelButtonClass: "cancel_btn", //取消自定义类名
        // confirmButtonClass: "confirm_btn", //确认自定义类名
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await TenantDelete(this.customerId);
          if (res.code !== 200) {
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getLandlordAjax();
          this.$router.go(-1);
        })
        .catch(() => {
          console.log(1);
        });
    },
    // 重置按钮
    resetPasswordBtn() {
      this.resetVisible = true;
    },
    // 编辑信息
    editInformation() {
      this.userInfoVisible = true;
      this.userInfoFrom=this.userInfo
    },
    // 分配运营管家
    allotBtn() {
      this.allotVisible = true;
    },
    // 删除图片
    handleRemove(file) {
      var index = this.sizeForm.img.indexOf(file.response.msg);
      if (index !== -1) {
        this.sizeForm.img.splice(index, 1);
      }
    },
    // 查看沟通日志图片
    getImg(item) {
      this.srcList = [];
      this.srcList.push(item);
    },
    // 查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible_img = true;
    },
    // 上传图片按钮
    handleAvatarSuccessFour(response) {
      if (this.sizeForm.img.indexOf(response.msg) == -1) {
        this.sizeForm.img.push(response.msg);
      }
    },
    // 新增树形
    handleNodeClickTwo(data) {
      this.formInline = {
        pageNum: 1,
        pageSize: 30,
        userName: "",
        deptPost: "",
        deptId: "100"
      };
      this.formInline.deptId = data.id;
      this.onSubmit();
    },
    async onSubmit() {
      const { data: res } = await UserListsAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.LandlordList = res.rows;
    },
    // Tag删除标签
    handleCloseTagOne(tag) {
      this.dynamicTagsOne.splice(this.dynamicTagsOne.indexOf(tag), 1);

      for (var k in this.checkListPost) {
        if (this.dynamicTagsOne.indexOf(this.checkListPost[k].postName) == -1) {
          this.checkListPost.splice(k, 1);
          return;
        }
      }
    },
    async ChangeStatus() {
      const { data: res } = await hourseLoadChangeStatus({
        cHouSteward: this.dynamicTagsOne.toString(),
        cStewardId: this.checkListPostList.toString(),
        customerId: this.houseId
      });
      if (res.code !== 200) {
        return this.$message({
          message: res.msg,
          type: "error"
        });
      }
        this.getLandlordAjax();
      this.allotVisible = false;
      return this.$message({
        message: res.msg,
        type: "success"
      });
    },
    // 渲染tag标签
    handleCheckAllChange(val) {
      // this.dynamicTagsOne = [];
      // this.checkListPostList = [];
      this.dynamicTagsOne = val.map(item => {
        return item.userName;
      });
      this.checkListPostList = this.checkListPost.map(item => {
        return item.userId;
      });
      console.log(this.checkListPostList, this.dynamicTagsOne);
    },
    // 加载更多
    moreList() {
      if (this.pageSize * this.pageNum < this.total) {
        this.pageNum++;
        this.getLandlordAjax();
      }
    },
    // 回复
    async replyBtn() {
      if (this.sizeForm.img.length <= 0 && this.cOperMemo == "")
        return this.$message({
          type: "warning",
          message: "回复内容不能为空！！！"
        });

      const { data: res } = await replyAjax({
        cOperMemo: this.cOperMemo,
        houseId: this.houseId,
        picList: this.sizeForm.img
      });
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      }
      this.$message({
        type: "success",
        message: "回复成功！"
      });
      this.$refs["my-upload"].clearFiles();
      this.boxList = [];
      this.getLandlordAjax();
      this.cOperMemo = "";
      this.sizeForm.img = "";
      console.log(this.sizeForm.img);
    },
    // 重置密码
    async resetUser() {
      const { data: res } = await resetUserPwd(this.customerId, "12345678");
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      } else {
        this.resetVisible = false;
        this.getLandlordAjax();
        return this.$message({
          type: "success",
          message: res.msg
        });
      }
    },
    // 编辑个人信息
    async userInfoBtn() {
        let flag=false
        this.$refs['userInfoFrom'].validate((valid) => {
            flag=valid
        });
        if (!flag) {
            this.$message.error('您的输入有误')
            return;
        }
        const { data: res } = await customerChangeStatus(this.userInfoFrom);
        if (res.code !== 200) {
            return this.$message({
                type: "error",
                message: res.msg
            });
        } else {
            this.userInfoVisible = false;
            this.getLandlordAjax();
            return this.$message({
                type: "success",
                message: res.msg
            });
        }

    }
  }
};
</script>
<style lang="less" scoped>
.userinfo {
  height: 180px;
  margin-bottom: 30px;
  .info_left {
    width: 466px;
    float: left;
    .info_left_img {
      float: left;
      overflow: hidden;
      border-radius: 50%;
      width: 150px;
      height: 150px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .info_left_text {
      float: left;
      margin-left: 30px;
      .userName {
        margin-top: 10px;
        font-family: Microsoft YaHei;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
      }
      .authentication {
        margin-top: 15px;
        font-weight: bold;
        width: 72px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        border-radius: 6px;
        background-color: #f6b439;
      }
      .authentication_else {
        margin-top: 15px;
        font-weight: bold;
        width: 72px;
        height: 30px;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        border-radius: 6px;
        background-color: #d2d2d2;
      }
      .userNumber {
        margin-top: 38px;
        font-size: 18px;
      }
    }
  }
  .info_right {
    float: right;
    height: 48px;
    width: 900px;
    margin-top: 102px;
    .el-button {
      font-size: 16px;
      height: 48px;
      width: 120px;
      padding: 0;
      float: right;
      margin: 0;
      color: #fff;
      margin-right: 30px;
    }
  }
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.title {
  position: relative;
  width: 150px;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
  text-indent: 15px;
}
.title::before {
  position: absolute;
  left: 0px;
  top: -3px;
  height: 36px;
  width: 6px;
  content: "";
  border-radius: 3px;
  background-color: #f6b439;
}
.user_message {
  margin-top: 25px;
  padding: 20px 15px;
  margin-bottom: 60px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  .message {
    position: relative;
    height: 45px;
    font-size: 16px;
    .message_left {
      position: absolute;
      top: 0px;
      left: 0px;
      line-height: 45px;
    }
    .message_right {
      position: absolute;
      top: 0px;
      left: 548px;
      line-height: 45px;
    }
  }
}
.record {
  padding: 20px 15px;
  margin-bottom: 30px;
}
.el-table {
  margin-top: 10px;
}
.QuickMark {
  float: left;
  margin-right: 12px;
  width: 80px;
  height: 80px;
}
/deep/.image-slot {
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.communication_box {
  width: 1600px;
  // height: 524px;
  border: 1px solid #e1e1e1;
  border-bottom: none;
  box-sizing: border-box;
  .communication_list {
    padding: 16px 13px;
    border-bottom: 1px solid #e1e1e1;
    .communication_list_top {
      font-size: 16px;
      color: #171a1e;
      margin-bottom: 8px;
    }
    .communication_list_center {
      height: 21px;
      font-size: 16px;
      color: #999;
      margin-bottom: 10px;
    }
  }
}

.communication_list_bottom {
  height: 80px;
}
.reply {
  position: relative;
  max-width: 1600px;
  min-height: 163px;
  background: #f2f2f2;
  border: 1px solid #e1e1e1;
  .reply_text {
    /deep/.el-textarea {
      background-color: #f2f2f2;
      border: #f2f2f2;
      textarea {
        font-size: 14px;
        background-color: #f2f2f2;
        border: #f2f2f2;
      }
    }
  }

  .reply_img {
    position: relative;
    margin-top: 28px;
    margin-left: 11px;
    margin-bottom: 27px;
    .el-button {
      color: #666666;
      position: absolute;
      right: 20px;
      bottom: -12px;
      background-color: #f2f2f2;
      border: #f2f2f2;
      padding: 0;
      width: 66px;
      height: 50px;
      line-height: 40px;
      font-size: 16px;
      /deep/ .iconfont {
        font-size: 25px;
      }
    }
    button:hover {
      color: #2f80ed;
    }
  }
}
.checkBox {
  cursor: pointer;
  color: #666666;
  line-height: 20px;
  text-align: center;
  width: 1600px;
  height: 20px;
  font-size: 12px;
  background-color: #f2f2f2;
  .el-icon-arrow-down {
    font-size: 14px;
  }
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  height: 80px;
  width: 80px;
}
.cancel {
  width: 72px;
  height: 36px;
  background-color: #f2f2f2;
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  border-radius: 4px;
}
.success_Btn {
  margin-left: 24px;
  width: 72px;
  height: 36px;
  background-color: #f6b439;
  border: 1px solid #f6b439;
  box-sizing: border-box;
  border-radius: 4px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
.title_center {
  /deep/.el-dialog__header {
    text-align: center;
  }
}
.resetPassText {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.333333px;
  text-align: center;
  color: #999999;
}
.AddLabel {
  width: 540px;
  min-height: 42px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  margin-bottom: 24px;
  .el-tag.el-tag--warning {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
}
/deep/.el-dialog__body {
  padding: 24px 30px;
}
/deep/.el-dialog__header {
  padding: 40px 30px 0;
}
/deep/.el-dialog__footer {
  padding: 10px 30px 20px;
}
.select_list_tree {
  overflow: hidden;
  width: 540px;
  padding: 20px 30px;
  border: 1px solid #e1e1e1;
  .treeList {
    float: left;
    width: 280px;
  }
  .select_list_checkBox {
    padding: 0 30px 0 30px;
    float: right;
    width: 198px;
    border-left: 1px solid #e1e1e1;
    .select_list_checkBox_list {
      width: 100%;
      height: 32px;
    }
  }
}
</style>
